/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Date } from '../../models/date';

export interface ApiWebInstytucjeNipPlikiGet$Xml$Params {
  nip: string;
  hashJawny?: string;
  hashZaszyfrowany?: string;
  ilosc?: number;
  od?: number;
  status?: Array<any>;
  wyslanePo?: Date;
  wyslanePrzed?: Date;
}

export function apiWebInstytucjeNipPlikiGet$Xml(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipPlikiGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipPlikiGet$Xml.PATH, 'get');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.query('hashJawny', params.hashJawny, {});
    rb.query('hashZaszyfrowany', params.hashZaszyfrowany, {});
    rb.query('ilosc', params.ilosc, {});
    rb.query('od', params.od, {});
    rb.query('status', params.status, {});
    rb.query('wyslanePo', params.wyslanePo, {});
    rb.query('wyslanePrzed', params.wyslanePrzed, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      }>;
    })
  );
}

apiWebInstytucjeNipPlikiGet$Xml.PATH = '/api/web/instytucje/{nip}/pliki';
